<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card color="primary" dark>
          <v-card-title>
            <span v-if="enableLocation">
              <v-select
                v-model="location"
                :items="locations"
                label="UPTD PSDA"
                prepend-icon="mdi-map"
                required
                @change="getStations(location)"
              ></v-select>
            </span>
            <span v-else>
              <v-select
                v-model="location"
                :items="locations"
                label="UPTD PSDA"
                prepend-icon="mdi-map"
                required
                readonly
                @change="getStations(location)"
              ></v-select>
            </span>
            <v-select
              v-model="station"
              :items="stations"
              label="Station"
              prepend-icon="mdi-memory"
              required
              return-object
              @change="getData(station.value,tab,date,time,station.satuan,station.text)"
            ></v-select>

            <!-- Date / month picker -->
            <v-dialog
              v-if="tab !== 3"
              ref="dialogDate"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Pick Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-if="modal"
                v-model="date"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogDate.save(date);getData(station.value,tab,date,time,station.satuan,station.text);modal=false"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-dialog
              v-else
              ref="dialogMonth"
              v-model="modalMonth"
              :return-value.sync="month"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="month"
                  label="Pick Month"
                  prepend-icon="mdi-calendar-month"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-if="modalMonth"
                v-model="month"
                type="month"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modalMonth = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogMonth.save(month);getData(station.value,tab,date,time,station.satuan,station.text);modalMonth=false"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-dialog
              v-if="tab !== 3"
              ref="dialog"
              v-model="modal2"
              :return-value.sync="time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="time"
                  label="Choose Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="modal2"
                v-model="time"
                full-width
                :allowed-minutes="allowedStep"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(time);getData(station.value,tab,date,time,station.satuan,station.text)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
            <download-csv
              v-if="tab !== 3"
              class   = "btn btn-default"
              :data   = "fileDownload"
              :name    = "csvTitle"
              separator-excel
              :labels  = "labelsCSV">
              <v-btn class="float-start mb-2" color="white" text><v-icon center>mdi-download</v-icon></v-btn>
            </download-csv>
            <v-btn
              v-else
              class="float-start mb-2"
              color="white"
              text
              :loading="monthlyDownloading"
              :disabled="!station"
              @click="downloadMonthlyCsv"
            >
              <v-icon center>mdi-download</v-icon>
            </v-btn>
          </v-card-title>
             <v-tabs
              v-model="tab"
              background-color="primary"
              color="white"
              show-arrows
              grow
              @change="getData(station.value,tab,date,time,station.satuan,station.text)"
            >
              <v-tabs-slider color="#0897d7"></v-tabs-slider>
              <v-tab
                v-for="item in items"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">

              <!-- 2 Hours -->
              <v-tab-item>
                <v-card flat class="text-center">
                  <Bar
                    class="d-none d-md-flex"
                    :chart-options="chartOptions"
                    :chart-data="chartDataDaily"
                    :height="200"
                  />
                  <Bar
                    class="d-flex d-md-none"
                    :chart-options="chartOptions"
                    :chart-data="chartDataDaily"
                    :height="350"
                  />
                </v-card>
              </v-tab-item>

              <!-- 4 Hours -->
              <v-tab-item>
                <v-card flat class="text-center">
                <Bar
                  class="d-none d-md-flex"
                  :chart-options="chartOptions"
                  :chart-data="chartDataMonthly"
                  :height="200"
                />
                <Bar
                  class="d-flex d-md-none"
                  :chart-options="chartOptions"
                  :chart-data="chartDataMonthly"
                  :height="350"
                />
                </v-card>
              </v-tab-item>

              <!-- 24 Hours -->
              <v-tab-item>
                <v-card flat class="text-center">
                <Bar
                  class="d-none d-md-flex"
                  :chart-options="chartOptions"
                  :chart-data="chartDataYearly"
                  :height="200"
                />
                <Bar
                  class="d-flex d-md-none"
                  :chart-options="chartOptions"
                  :chart-data="chartDataYearly"
                  :height="350"
                />
                </v-card>
              </v-tab-item>

              <!-- Monthly -->
              <v-tab-item>
                <v-card flat class="text-center">
                <Bar
                  class="d-none d-md-flex"
                  :chart-options="chartOptions"
                  :chart-data="chartDataFullMonth"
                  :height="200"
                />
                <Bar
                  class="d-flex d-md-none"
                  :chart-options="chartOptions"
                  :chart-data="chartDataFullMonth"
                  :height="350"
                />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"
import moment from 'moment'
import axios from 'axios'
import { Bar } from 'vue-chartjs/legacy'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

import csvtojson from 'csvtojson'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const TMA_CHART_MONTHLY_URL = 'https://us-central1-rainmonitor-b0968.cloudfunctions.net/radar/chartMonthly'
const TMA_CHART_TZ_OFFSET = 7

export default ({
  components: { Bar },
  data: () => ({
    modal:false,
    modal2:false,
    modalMonth:false,
    date:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    month:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 7),
    time:null,
    devices:[],
    data:[],
    offset:0,

    tab: null,
    items: [
      '2 Hours', '4 Hours', '24 Hours', 'Monthly'
    ],
  
    dialog:false,
    ID:null,
    chartDataDaily: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataMonthly: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataYearly: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataFullMonth: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartOptions: {
      responsive: true
    },
    headersDetail: [
      {
        text: 'Tanggal',
        align: 'start',
        value: 'tanggal',
      },
      { text: 'Curah (mm)', value: 'curah' },
    ],
    fileDatum:[],
    labels:[],
    datasets:[],
    location:null,
    locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
    station: null,
    stations:[],
    csvTitle:null,
    labelsCSV:{
      Time: 'Time',
      Baterai: 'Baterai (V)',
      Charger: 'Charger',
      FullCharger: 'Full Charger',
      TinggiPermukaanAir: 'Tinggi Muka Air (m)'
    },
    fileDownload:[],
    enableLocation:true,
    dataRequestId:0,
    monthlyCache: {
      key: null,
      csvTexts: [],
      chart: null,
    },
    monthlyDownloading: false,
    
  }),
  async mounted() {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    this.time=moment.unix(Date.now()/1000).utcOffset(this.offset).format("HH:mm")
    let loader = this.$loading.show()
    let setByLocation=false
    await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
      setByLocation=doc.data().location
    }).catch(() => {
      loader.hide()
    })

    if (localStorage.getItem('location')=='MARNOV') {
      this.locations.push("MARNOV")
    }

    if (setByLocation) {
      this.location=localStorage.getItem('location')
      this.enableLocation=false
      await db.collection('radar').where('location','==',localStorage.getItem('location')).get().then((querySnapshot) => {
        this.stations=[]
        this.station=null
        querySnapshot.forEach((doc) => {
          this.stations.push({value:doc.id,text:doc.data().station, satuan: doc.data().satuan})
        });
      })
    }
    loader.hide()
  },
  watch: {
    date:function (val) {
      console.log(val)
    }
  },
  methods: {
    updateTime (time) {
      return moment.unix(time/1000).utcOffset(this.offset).format("HH:mm")
    },
    allowedStep: m => m % 60 === 0,
    async getStations (location) {
      await db.collection('radar').where('location','==',location).get().then((querySnapshot) => {
        this.stations=[]
        this.station=null
        querySnapshot.forEach((doc) => {
          this.stations.push({value:doc.id,text:doc.data().station, satuan: doc.data().satuan})
        });
      })
    },
    parseTmaCsv(csvString) {
      const lines = String(csvString || '').trim().split(/\r?\n/)
      if (lines.length < 2) return []
      const headers = lines[0].split(',')
      const timeIdx = headers.indexOf('Time')
      const bateraiIdx = headers.indexOf('Baterai')
      const chargerIdx = headers.indexOf('Charger')
      const fullChargerIdx = headers.indexOf('FullCharger')
      const tinggiIdx = headers.indexOf('TinggiPermukaanAir')
      if (timeIdx < 0 || tinggiIdx < 0) return []
      const rows = []
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i]
        if (!line) continue
        const cols = line.split(',')
        rows.push({
          Time: cols[timeIdx],
          Baterai: bateraiIdx >= 0 ? cols[bateraiIdx] : '',
          Charger: chargerIdx >= 0 ? cols[chargerIdx] : '',
          FullCharger: fullChargerIdx >= 0 ? cols[fullChargerIdx] : '',
          TinggiPermukaanAir: cols[tinggiIdx],
        })
      }
      return rows
    },
    async fetchMonthlyCsvTexts(station, start, end, cacheKey, requestId) {
      if (this.monthlyCache.key === cacheKey && this.monthlyCache.csvTexts && this.monthlyCache.csvTexts.length) {
        return this.monthlyCache.csvTexts
      }
      const collectionSnapshot = await db.collection('radar').doc(station).collection('data')
        .orderBy("time","asc")
        .where("time", ">=", start)
        .where("time", "<=", end)
        .get()
      if (requestId != null && requestId !== this.dataRequestId) return null
      const csvTexts = collectionSnapshot.docs.map((doc) => doc.data().data || '')
      this.monthlyCache = {
        key: cacheKey,
        csvTexts,
        chart: this.monthlyCache.key === cacheKey ? this.monthlyCache.chart : null,
      }
      return csvTexts
    },
    chartFromBuckets(buckets, satuan) {
      const bucketKeys = Object.keys(buckets || {}).map(Number).filter((k) => !Number.isNaN(k)).sort((a, b) => a - b)
      return {
        labels: bucketKeys.map((key) => moment(key).utcOffset(TMA_CHART_TZ_OFFSET).format("DD MMM HH:mm")),
        datasets: bucketKeys.map((key) => {
          const entry = buckets[String(key)] || buckets[key]
          const avg = Number(entry.sum) / Number(entry.count)
          return satuan=='cm' ? Math.round(avg * 100) : Math.round(avg * 1000) / 1000
        }),
      }
    },
    async fetchMonthlyChart(station, monthPick, satuan, requestId) {
      const cacheKey = `${station}_${monthPick}`
      if (this.monthlyCache.key === cacheKey && this.monthlyCache.chart) {
        return this.monthlyCache.chart
      }
      const cacheSnap = await db.collection('radar').doc(station).collection('chartMonthly').doc(monthPick).get()
      if (requestId != null && requestId !== this.dataRequestId) return null
      let buckets = null
      if (cacheSnap.exists && cacheSnap.data().buckets && Object.keys(cacheSnap.data().buckets).length > 0) {
        buckets = cacheSnap.data().buckets
      } else {
        const res = await axios.get(`${TMA_CHART_MONTHLY_URL}/${station}/${monthPick}`)
        if (requestId != null && requestId !== this.dataRequestId) return null
        buckets = res.data && res.data.buckets ? res.data.buckets : null
      }
      const chart = this.chartFromBuckets(buckets || {}, satuan)
      this.monthlyCache = {
        key: cacheKey,
        csvTexts: this.monthlyCache.key === cacheKey ? this.monthlyCache.csvTexts : [],
        chart,
      }
      return chart
    },
    buildGranularRows(csvTexts, satuan) {
      const valueOf = (tinggi) => satuan=='cm'?Math.round(tinggi*100):Number(tinggi)
      const rows = []
      for (let i = 0; i < csvTexts.length; i++) {
        const parsed = this.parseTmaCsv(csvTexts[i])
        for (let j = 0; j < parsed.length; j++) {
          const data = parsed[j]
          const ts = moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf()
          if (!ts) continue
          rows.push({
            Time: moment.unix(ts/1000).utcOffset(this.offset).format("DD/MM/YYYY HH:mm:ss"),
            Baterai: data.Baterai,
            Charger: data.Charger,
            FullCharger: data.FullCharger,
            TinggiPermukaanAir: valueOf(data.TinggiPermukaanAir),
          })
        }
      }
      return rows
    },
    rowsToCsv(rows) {
      const headers = ['Time','Baterai (V)','Charger','Full Charger',`Tinggi Permukaan Air (${this.station && this.station.satuan ? this.station.satuan : 'm'})`]
      const lines = [headers.join(';')]
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        lines.push([
          row.Time,
          row.Baterai,
          row.Charger,
          row.FullCharger,
          row.TinggiPermukaanAir,
        ].join(';'))
      }
      return lines.join('\n')
    },
    triggerFileDownload(filename, text) {
      const element = document.createElement('a')
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text))
      element.setAttribute('download', filename)
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    },
    async downloadMonthlyCsv() {
      if (!this.station || this.tab !== 3) return
      this.monthlyDownloading = true
      try {
        const station = this.station.value
        const satuan = this.station.satuan
        const stationName = this.station.text
        const monthPick = this.month
        const cacheKey = `${station}_${monthPick}`
        const start = moment(monthPick, "YYYY-MM").startOf('month').valueOf()
        const end = moment(monthPick, "YYYY-MM").endOf('month').valueOf()
        const csvTexts = await this.fetchMonthlyCsvTexts(station, start, end, cacheKey, null)
        if (!csvTexts) return
        const rows = this.buildGranularRows(csvTexts, satuan)
        const csvTitle = `${this.location}_${stationName}_${monthPick}_Monthly.csv`
        this.triggerFileDownload(csvTitle, this.rowsToCsv(rows))
      } finally {
        this.monthlyDownloading = false
      }
    },
    async getData(station,tab,datePick,timePick,satuan,stationName) {
      if (station==null || tab==null) return
      if (tab!==3 && (timePick==null || datePick==null)) return

      const requestId = ++this.dataRequestId
      const labels = []
      const datasets = []
      const fileDownload = []
      const valueOf = (tinggi) => satuan=='cm'?Math.round(tinggi*100):tinggi
      const pushRow = (data, label) => {
        const ts = moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf()
        labels.push(label(ts))
        datasets.push(valueOf(data.TinggiPermukaanAir))
        fileDownload.push({
          Time:moment.unix(ts/1000).utcOffset(this.offset).format("DD/MM/YYYY HH:mm:ss"),
          Baterai: data.Baterai,
          Charger: data.Charger,
          FullCharger: data.FullCharger,
          TinggiPermukaanAir: valueOf(data.TinggiPermukaanAir)
        })
      }
      const loadDocs = async (start, end, onRow) => {
        const collectionSnapshot = await db.collection('radar').doc(station).collection('data').orderBy("time","asc").where("time", ">=", start).where("time", "<=", end).get()
        for (const doc of collectionSnapshot.docs) {
          if (requestId !== this.dataRequestId) return false
          const csvRow = await csvtojson().fromString(doc.data().data)
          csvRow.forEach((data) => onRow(data))
        }
        return requestId === this.dataRequestId
      }
      const applyChart = (chartKey, csvTitle, chartLabels, chartDatasets, chartLabel) => {
        if (requestId !== this.dataRequestId) return
        this.fileDownload = fileDownload
        this.labelsCSV.TinggiPermukaanAir=`Tinggi Permukaan Air (${satuan})`
        this.csvTitle = csvTitle
        this[chartKey] = {
          labels: chartLabels,
          datasets: [ { label: chartLabel || `Tinggi Permukaan Air (${satuan})`,data: chartDatasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
        }
      }

      if (tab==0) {
        let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
        let end = start-7200000;
        const ok = await loadDocs(end, start, (data) => pushRow(data, (ts) => this.updateTime(ts)))
        if (!ok) return
        applyChart('chartDataDaily', `${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_2Hours.csv`, labels, datasets)
        this.modal=false
      } else if (tab==1) {
        let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
        let end = start-14400000;
        const ok = await loadDocs(end, start, (data) => pushRow(data, (ts) => this.updateTime(ts)))
        if (!ok) return
        applyChart('chartDataMonthly', `${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_4Hours.csv`, labels, datasets)
        this.modal=false
      } else if (tab==2) {
        let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
        let end = start-86400000;
        const ok = await loadDocs(end, start, (data) => pushRow(data, (ts) => this.updateTime(ts)))
        if (!ok) return
        applyChart('chartDataYearly', `${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_24Hours.csv`, labels, datasets)
        this.modal=false
      } else if (tab==3) {
        const monthPick = this.month
        const loader = this.$loading.show()
        try {
          const chart = await this.fetchMonthlyChart(station, monthPick, satuan, requestId)
          if (!chart || requestId !== this.dataRequestId) return
          this.fileDownload = []
          this.labelsCSV.TinggiPermukaanAir=`Tinggi Permukaan Air (${satuan})`
          this.csvTitle=`${this.location}_${stationName}_${monthPick}_Monthly.csv`
          this.chartDataFullMonth = {
            labels: chart.labels,
            datasets: [ { label: `Tinggi Permukaan Air (${satuan})`,data: chart.datasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
          }
          this.modalMonth=false
        } finally {
          loader.hide()
        }
      }
    },
  }
})
</script>

